// extracted by mini-css-extract-plugin
module.exports = {"online-icon":"LastOnlineStatus_online-icon__9dlzQ","icon-with-hour":"LastOnlineStatus_icon-with-hour__reMYp","last-online-label":"LastOnlineStatus_last-online-label__0Ct8U"};